import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/** Pending placeholder for the Referral screen — shares the View frame with the real content. */
export function ReferralPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={220} height={32} />
        </View.Header>
        {/* Mirrors the real screen's tightened header gap and its 24/48 page rhythm so the crossfade
            shifts nothing. */}
        <View.Body
          className="
            gap-60
            md:gap-section md:pt-70
          "
        >
          <div className="flex gap-stack">
            <Skeleton variant="text" width={120} height={24} />
            <Skeleton variant="text" width={120} height={24} />
          </div>
          <Skeleton variant="block" height={180} />
          <div
            className="
              flex flex-col gap-stack
              md:flex-row
            "
          >
            <Skeleton variant="block" height={160} className="flex-1" />
            <Skeleton variant="block" height={160} className="flex-1" />
            <Skeleton variant="block" height={160} className="flex-1" />
          </div>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
